// extracted by mini-css-extract-plugin
export default {"hamburgerWrapper":"hamburger-module--hamburger-wrapper--60e41","inner":"hamburger-module--inner--d324f","open":"hamburger-module--open--a28ed","box":"hamburger-module--box--01c40"};